"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

// Libraries
var Timer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Timer, _React$Component);

  function Timer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Timer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Timer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      timer: null,
      counter: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "check", function (_ref) {
      var loading = _ref.loading;

      if (loading && !_this.state.timer) {
        _this.start();
      }

      if (!loading && _this.state.timer) {
        _this.stop();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "start", function () {
      _this.setState({
        timer: setInterval(_this.tick, 10),
        counter: 0
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stop", function () {
      clearInterval(_this.state.timer);

      _this.setState({
        timer: null
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "tick", function () {
      _this.setState(function (_ref2) {
        var counter = _ref2.counter;
        return {
          counter: counter + 10
        };
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Timer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.check(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.check(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        counter: this.state.counter
      });
    }
  }]);
  return Timer;
}(_react["default"].Component);

var _default = Timer;
exports["default"] = _default;